import { Link } from "react-router-dom";
import BgShape from "../images/hero/hero-bg.png";
import HeroCar from "../images/hero/main-car.png";
import { useEffect, useState } from "react";

function Hero() {
  const [goUp, setGoUp] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: (0, 0), behavior: "smooth" });
  };

  useEffect(() => {
    const onPageScroll = () => {
      if (window.pageYOffset > 600) {
        setGoUp(true);
      } else {
        setGoUp(false);
      }
    };
    window.addEventListener("scroll", onPageScroll);

    return () => {
      window.removeEventListener("scroll", onPageScroll);
    };
  }, []);
  return (
    <>
      <section id="home" className="hero-section">
        <div className="container">
          <img className="bg-shape" src={BgShape} alt="bg-shape" />
          <div className="hero-content">
            <div className="hero-content__text">
              <h4>Premium Outstation Cabs by MyDearCab</h4>
              <h1>
                Your <span>Trusted</span> Travel Partner
              </h1>
              <p>
                Experience premium outstation cab services with MyDearCab.
                Reliable, comfortable, and affordable travel solutions for all
                your journey needs.
              </p>
              <div className="hero-content__text__btns">
                <a
                  className="hero-content__text__btns__book-ride"
                  target="_blank"
                  href="https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab"
                >
                  Book Ride &nbsp; <i className="fa-solid fa-circle-check"></i>
                </a>
              </div>
            </div>

            {/* img */}
            <img
              src={HeroCar}
              alt="car-img"
              className="hero-content__car-img"
            />
          </div>
        </div>

        {/* page up */}
        <div
          onClick={scrollToTop}
          className={`scroll-up ${goUp ? "show-scroll" : ""}`}
        >
          <i className="fa-solid fa-angle-up"></i>
        </div>
      </section>
    </>
  );
}

export default Hero;
